import { FC } from "react"
import { IconProps } from "@/components/shared/Icon"

const TemperatureIcon: FC<IconProps> = ({ ...props }) => {
   return (
      <svg
         viewBox="0 0 24 24"
         fill="none"
         {...props}
      >
         <g clipPath="url(#clip0_17477_92842)">
            <path
               d="M12.85 16.6666V2.72664C12.85 1.25664 11.65 0.0566406 10.18 0.0566406C8.71 0.0566406 7.52 1.25664 7.52 2.72664V16.6666C6.57 17.4566 6 18.6266 6 19.8766C6 22.1866 7.88 24.0566 10.18 24.0566C12.48 24.0566 14.36 22.1766 14.36 19.8766C14.36 18.6366 13.79 17.4566 12.84 16.6666H12.85ZM10.18 22.9066C8.51 22.9066 7.15 21.5466 7.15 19.8766C7.15 18.7566 7.76 17.7866 8.67 17.2666V2.72664C8.67 1.88664 9.35 1.20664 10.19 1.20664C11.03 1.20664 11.71 1.88664 11.71 2.72664V17.2666C12.61 17.7966 13.23 18.7566 13.23 19.8766C13.23 21.5466 11.87 22.9066 10.2 22.9066H10.18Z"
               fill="currentColor"
            />
            <path
               d="M12.23 19.9666C12.23 21.0866 11.32 22.0066 10.19 22.0066C9.06 22.0066 8.15 21.0866 8.15 19.9666C8.15 19.1066 8.68 18.3766 9.43 18.0766V5.67664C9.43 5.25664 9.78 4.90664 10.2 4.90664C10.62 4.90664 10.97 5.25664 10.97 5.67664V18.0866C11.73 18.3866 12.25 19.1166 12.25 19.9766L12.23 19.9666Z"
               fill="currentColor"
            />
            <path
               d="M16.47 6.42664H14.49C14.02 6.42664 13.64 6.06664 13.64 5.61664C13.64 5.16664 14.02 4.80664 14.49 4.80664H16.47C16.94 4.80664 17.32 5.16664 17.32 5.61664C17.32 6.06664 16.94 6.42664 16.47 6.42664Z"
               fill="currentColor"
            />
            <path
               d="M16.47 10.1966H14.49C14.02 10.1966 13.64 9.83664 13.64 9.38664C13.64 8.93664 14.02 8.57664 14.49 8.57664H16.47C16.94 8.57664 17.32 8.93664 17.32 9.38664C17.32 9.83664 16.94 10.1966 16.47 10.1966Z"
               fill="currentColor"
            />
            <path
               d="M16.36 13.9666H14.38C13.91 13.9666 13.53 13.6066 13.53 13.1566C13.53 12.7066 13.91 12.3466 14.38 12.3466H16.36C16.83 12.3466 17.21 12.7066 17.21 13.1566C17.21 13.6066 16.83 13.9666 16.36 13.9666Z"
               fill="currentColor"
            />
         </g>
      </svg>
   )
}

export default TemperatureIcon
